module.exports = ".m-stack__item.m-stack__item--middle.m-brand__logo {\n  width: 150px; }\n\n.bluepark__logo {\n  width: 100%; }\n\nli.m-menu__item.bp-logout {\n  padding: 9px 30px;\n  text-align: center; }\n\nli#user-menu {\n  position: absolute;\n  right: 0; }\n\nli.m-nav__item {\n  padding: 1rem; }\n\n.row.center {\n  height: 100%;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/layouts/header-nav/header-nav.component.scss
// module id = ./src/app/theme/layouts/header-nav/header-nav.component.scss
// module chunks = main